import React from "react";

const PrivacyPolicyEn = () => {
  return (
    <div style={{ padding: "48px", lineHeight: "1.6", fontFamily: "Arial, sans-serif" }}>
      <h1>Privacy Policy for Fotogram Technology</h1>
      <p><strong>Effective Date:</strong> 22.11.2024</p>

      <section>
        <h2>1. Data Controller and Contact Information</h2>
        <p>
          <strong>Data Controller:</strong>
          <br />
          Fotogram Technology
          <br />
          CEO: Eilon Mario Netzer
          <br />
          Address: 1004 Street Building 18, PO Box 50255, 1616102 Nazareth, Israel
          <br />
          Email: <a href="mailto:info@fotogram.app">info[at]fotogram.app</a>
          <br />
          Website: <a href="https://fotogram.technology" target="_blank" rel="noopener noreferrer">fotogram.technology</a>
        </p>
      </section>

      <section>
        <h2>2. Data Processing Exclusively in Germany</h2>
        <h3>2.1 Server Location</h3>
        <p>
          All personal data collected and processed by Fotogram Technology is stored exclusively on servers located in Germany. 
          These servers comply with GDPR requirements and uphold the highest security standards.
        </p>
        <h3>2.2 No Data Transfers Abroad</h3>
        <p>
          Although Fotogram Technology is headquartered in Israel, no personal data is transferred to non-EU or non-EEA countries.
        </p>
      </section>

      <section>
        <h2>3. Categories of Personal Data</h2>
        <p>Fotogram Technology processes the following types of personal data:</p>
        <ul>
          <li><strong>Usage Data:</strong> IP address, browser type, operating system, access times.</li>
          <li><strong>Customer Data:</strong> Name, email address, phone number, address, payment information.</li>
          <li><strong>Content Data:</strong> Uploaded images, videos, and comments.</li>
          <li><strong>Communication Data:</strong> Information from support inquiries and contact forms.</li>
          <li><strong>Technical Data:</strong> Device information, log files.</li>
        </ul>
      </section>

      <section>
        <h2>4. Purposes and Legal Basis for Processing</h2>
        <h3>4.1 Processing Purposes</h3>
        <p>We process your data for the following purposes:</p>
        <ul>
          <li>Providing and improving our services.</li>
          <li>Managing user accounts and contractual relationships.</li>
          <li>Processing payments and issuing invoices.</li>
          <li>Analyzing and optimizing the user experience.</li>
          <li>Complying with legal obligations.</li>
        </ul>
        <h3>4.2 Legal Basis for Processing</h3>
        <p>Processing is based on:</p>
        <ul>
          <li><strong>Art. 6(1)(a) GDPR (Consent):</strong> e.g., for newsletters or cookies.</li>
          <li><strong>Art. 6(1)(b) GDPR (Contract):</strong> e.g., for customer accounts and services.</li>
          <li><strong>Art. 6(1)(c) GDPR (Legal Obligation):</strong> e.g., for tax compliance.</li>
          <li><strong>Art. 6(1)(f) GDPR (Legitimate Interests):</strong> e.g., for security and analytics.</li>
        </ul>
      </section>

      <section>
        <h2>5. Cookies and Similar Technologies</h2>
        <h3>5.1 Types of Cookies Used</h3>
        <p>Our website uses the following types of cookies:</p>
        <ul>
          <li>Essential Cookies: Necessary for the basic functionality of the website.</li>
          <li>Functional Cookies: Enhance user experience by remembering preferences.</li>
          <li>Analytics Cookies: Collect anonymized data for performance analysis.</li>
          <li>Marketing Cookies: Enable personalized advertising.</li>
        </ul>
        <h3>5.2 Managing Cookies</h3>
        <p>
          You can manage or disable cookies through your browser settings or via our cookie banner.
        </p>
      </section>

      <section>
        <h2>6. Data Processing When Using Our Services</h2>
        <h3>6.1 Registration and User Accounts</h3>
        <p>
          When registering, we collect:
          <ul>
            <li>Name, email address, and password.</li>
            <li>Optional: Payment details.</li>
          </ul>
          <strong>Purpose:</strong> Managing your account and providing our services.
          <br />
          <strong>Legal Basis:</strong> Art. 6(1)(b) GDPR.
        </p>
        <h3>6.2 Contact Forms and Support Inquiries</h3>
        <p>
          When you contact us via forms or email, we process:
          <ul>
            <li>Your message, name, and email address.</li>
          </ul>
          <strong>Purpose:</strong> Responding to your inquiry.
          <br />
          <strong>Legal Basis:</strong> Art. 6(1)(b) GDPR.
        </p>
      </section>

      <section>
        <h2>7. Third-Party Services and Processors</h2>
        <ul>
          <li>
            <strong>Hosting Providers:</strong> Our German-based hosting providers ensure compliance with GDPR standards.
          </li>
        </ul>
      </section>

      <section>
        <h2>8. Contact for Data Protection Queries</h2>
        <p>
          <strong>Fotogram Technology</strong>
          <br />
          Email: <a href="mailto:datenschutz@fotogram.app">datenschutz@fotogram.app</a>
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicyEn;
